import { makeStyles } from "@material-ui/core/styles";
import analysisImg from "../../../images/contents/map/tropicalstorm/analysis.png";
import max35Img from "../../../images/contents/map/tropicalstorm/max35.png";
import max50Img from "../../../images/contents/map/tropicalstorm/max50.png";
import max64Img from "../../../images/contents/map/tropicalstorm/max64.png";
import tDImg from "../../../images/contents/map/tropicalstorm/TD.png";
import tSImg from "../../../images/contents/map/tropicalstorm/TS.png";
import tYImg from "../../../images/contents/map/tropicalstorm/TY.png";
import xTImg from "../../../images/contents/map/tropicalstorm/XT.png";
import { Box } from "@material-ui/core";
import { LegendBoxContentsName, LegendBoxList, LegendBoxListItem, LegendBoxListItemText } from "../../legend/LegendBoxComponents";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { exWxContentsState } from "../../../store/ExWxContentsState";
import { WX_ID_TROPICALCYCLONE } from "../../../store/WeatherContentsState";
import { TROPICALCYCLONE_TYPE_JMA, TROPICALCYCLONE_TYPE_JTWC, TROPICALCYCLONE_TYPE_WNI_GLOBAL_TC } from "../layers/TropicalCyclone";
import { useRecoilValue } from "recoil";

const useStyles = makeStyles((theme) => ({
  boxRoot: {
    display: 'flex',
    '& > *:not(:first-child)': {
      marginLeft: '10px',
    },
  },
  icon: {
    verticalAlign: "middle",
    maxHeight: "30px"
  },
  iconMini: {
    height: "20px"
  },
  trackLine:{
    position: 'relative',
    display:  'inline-block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '30px',
    height: '5px',
    '&:before': {
      position: 'absolute',
      display: 'block',
      content: "''",
      left: 0,
      width: '25px'
    }
  },
  trackActual: {
    '&:before': {
      borderTop: '4px solid #802020'
    }
  },
  trackForecast: {
    '&:before': {
      borderTop: '4px solid #0000ff'
    }
  },
  trackActualJMA: {
    '&:before': {
      borderTop: '4px solid #202080'
    }
  },
  trackForecastJMA: {
    '&:before': {
      borderTop: '4px solid #ffffff'
    }
  },
  legendBoxListItem: {
    height: 30
  },
  legendBoxListItemMultiLine: {
    display: 'flex',
    alignItems: 'flex-start',
    height: 45,
    marginTop: 4,
  },
  circle: {
    width: '15px',
    height: '15px',
    borderRadius: '50%',
    border: '2px solid transparent',
  },
}));

function LegendTropicalCyclone() {
  const exState = useRecoilValue(exWxContentsState(WX_ID_TROPICALCYCLONE));
  const classes = useStyles();
  const {t} = useTranslation();

  const enableTropicalStorm = exState.visible[TROPICALCYCLONE_TYPE_WNI_GLOBAL_TC] || exState.visible[TROPICALCYCLONE_TYPE_JTWC];
  const enableTyhoon = exState.visible[TROPICALCYCLONE_TYPE_JMA];
  return (
    <Box className={classes.boxRoot}>
      {enableTropicalStorm &&
        <Box>
          <LegendBoxContentsName>{t('WNI Global TC')} / {t('JTWC')}</LegendBoxContentsName>
          <LegendBoxList>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={tDImg} alt={t('Tropical depression')} className={classes.icon}/>
              <LegendBoxListItemText>{t('Tropical depression')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={tSImg} alt={t('Tropical Storm')} className={classes.icon}/>
              <LegendBoxListItemText>{t('Tropical Storm')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={tYImg} alt={t('Typhoon/Hurricane/Cyclone')} className={classes.icon}/>
              <LegendBoxListItemText>{t('Typhoon/Hurricane/Cyclone')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={xTImg} alt={t('Extra Tropical Low')} className={classes.icon}/>
              <LegendBoxListItemText>{t('Extra Tropical Low')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <div className={clsx(classes.trackLine, classes.trackActual)}/>
              <LegendBoxListItemText>{t('Track History')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <div className={clsx(classes.trackLine, classes.trackForecast)}/>
              <LegendBoxListItemText>{t('Forecast Track')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={max35Img} alt={t('35kt wind Radii')} className={clsx(classes.icon, classes.iconMini)}/>
              <LegendBoxListItemText>{t('35kt wind Radii')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={max50Img} alt={t('50kt wind Radii')} className={clsx(classes.icon, classes.iconMini)}/>
              <LegendBoxListItemText>{t('50kt wind Radii')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={clsx(classes.legendBoxListItem, classes.legendBoxListItemMultiLine)}>
              <img src={max64Img} alt={t('64kt wind Radii')} className={clsx(classes.icon, classes.iconMini)}/>
              <LegendBoxListItemText>{t('64kt wind Radii')}<br/>({t('Only JTWC)')}</LegendBoxListItemText>
            </LegendBoxListItem>
          </LegendBoxList>
        </Box>
      }
      {enableTyhoon &&
        <Box>
          <LegendBoxContentsName>{t('JMA')}</LegendBoxContentsName>
          <LegendBoxList>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={analysisImg} alt={t('Current Position')} className={classes.icon}/>
              <LegendBoxListItemText>{t('Current Position')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={tSImg} alt={t('Tropical Storm')} className={classes.icon}/>
              <LegendBoxListItemText>{t('Tropical Storm')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <img src={tYImg} alt={t('Typhoon/Hurricane/Cyclone')} className={classes.icon}/>
              <LegendBoxListItemText>{t('Typhoon/Hurricane/Cyclone')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <div className={clsx(classes.trackLine, classes.trackActualJMA)}/>
              <LegendBoxListItemText>{t('Track History')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <div className={clsx(classes.trackLine, classes.trackForecastJMA)}/>
              <LegendBoxListItemText>{t('Forecast Track')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.legendBoxListItem}>
              <div alt="Area Of Possible Position" className={classes.circle} style={{ borderColor: '#ffffff', borderStyle: 'dotted' }} />
              <LegendBoxListItemText>{t('Area Of Possible Position')}</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={clsx(classes.legendBoxListItem, classes.legendBoxListItemMultiLine)}>
              <div alt="Area Of Storm-Force Winds" className={classes.circle} style={{ borderColor: 'rgb(255,255,150)' }} />
              <LegendBoxListItemText>{t('Area Of Storm-Force Winds')}<br/>({t('Wind Speed 30kt or More')})</LegendBoxListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={clsx(classes.legendBoxListItem, classes.legendBoxListItemMultiLine)}>
              <div alt="Area Of Storm-Force Winds" className={classes.circle} style={{ borderColor: 'rgb(255,50,50)' }} />
              <LegendBoxListItemText>{t('Area Of Storm-Force Winds')}<br/>({t('Wind Speed 50kt or More')})</LegendBoxListItemText>
            </LegendBoxListItem>
          </LegendBoxList>
        </Box>
      }
    </Box>
  )
}

export default memo(LegendTropicalCyclone);